// PayPal ödeme uç noktaları (her ikisi de JWT gerektirir; Bearer interceptor ekler).
import api from '../../api/client';
import { unwrap, toApiError, ApiError } from '../../api/unwrap';

// POST /payments/paypal/create → BaseResponse{ data:{ orderId, approvalUrl } }
export const createPayPalOrder = async ({ productId, priceId }) => {
  try {
    return await api.post('/payments/paypal/create', { productId, priceId }).then(unwrap);
  } catch (error) {
    throw toApiError(error);
  }
};

// POST /payments/paypal/capture → DOĞRUDAN ProvisionEsimResponse (BaseResponse değil).
// HTTP 202 = işleniyor → kısa beklemeyle birkaç kez tekrar dener.
export const capturePayPalOrder = async (orderId) => {
  const maxAttempts = 4;
  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    let res;
    try {
      res = await api.post('/payments/paypal/capture', { orderId });
    } catch (error) {
      throw toApiError(error);
    }
    const data = res.data || {};
    // İşleniyor: Retry-After ~3sn, tekrar dene.
    if (res.status === 202 || data.status === 'processing') {
      await new Promise((r) => setTimeout(r, 3000));
      continue;
    }
    return data; // { success, message, error, data:{ qrCodeData, purchasedPlan, ... } }
  }
  throw new ApiError('processing-timeout', { code: 'PROCESSING' });
};
